<div class="olympic-container">
  <div class="number">{{number}}</div>
  <div class="description">
    <div class="description__title">{{title}}</div>
    <div class="description__subtitle">{{subtitle}}</div>
  </div>
</div>
